import type { FieldDto } from "../../types/field";
import { parseMediaNodeId } from "../media/parseMediaNodeId";
import { isFieldOptionsObject } from "./fieldOptions";

export type DisplayConfig = {
  content?: string;
  image_url?: string;
  image_node_id?: number | null;
};

export function resolveDisplayConfig(field: FieldDto): DisplayConfig {
  const fromDisplay = field.display;
  const options = isFieldOptionsObject(field.options) ? field.options : null;

  return {
    content: String(fromDisplay?.content ?? options?.content ?? "").trim(),
    image_url: String(
      fromDisplay?.image_url ?? options?.image_url ?? "",
    ).trim(),
    image_node_id: parseMediaNodeId(
      fromDisplay?.image_node_id ?? options?.image_node_id,
    ),
  };
}

export function hasDisplayContent(config: DisplayConfig): boolean {
  return Boolean(config.content || config.image_url);
}
